export const getters = {
  projects: state => state.projects,
  featuredProjects: state => state.projects.slice(0, 5)
};
